import Itinerary from "./Itinerary";

export const itinerary = {
  init: () => {
    const elements = document.querySelectorAll('.sd-florence-itinerary');
    if (elements) {
      elements.forEach(element => {
        new Itinerary(element)
      })
    }
  },
}

export default itinerary;